import { GET_STAFF_GROUPS, SUCCESS, FAIL } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  staffGroups: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_STAFF_GROUPS:
      return { ...state, isLoading: true };
    case `${GET_STAFF_GROUPS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        staffGroups: [...payload],
      };
    case `${GET_STAFF_GROUPS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
